<template>
  <div class="page-header">
    <div class="title">
      <b-container>
        <b-row>
          <b-col>
            <div class="main">
              <div>您好!欢迎来到广西建工建筑安装技工学校</div>
              <div>办学特色：工匠校园、智慧校园、绿色校园、装配校园</div>
              <div></div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="hand">
      <b-container>
        <b-row>
          <b-col>
            <div class="main">
              <div class="left">
                <div class="logo">
                  <img src="@/assets/img/logo.png" />
                </div>
                <div class="interval"></div>
                <div class="label">
                  <div>广西建工建筑安装技工学校</div>
                  <div>广西建筑工程职业技术学校</div>
                </div>
              </div>
              <div class="right">
                <div class="pr-3 zsrx">
                  <div class="text-center">招生热线</div>
                  <div class="d-flex">
                    <div class="d-flex flex-column justify-content-center" style="margin-right: 10px;">
                      <b-icon
                        font-scale="1.2"
                        class="text-primary"
                        icon="telephone-inbound-fill"
                        aria-hidden="true"
                      ></b-icon>
                    </div>
                    <div>
                      <div>0772-2521859</div>
                      <div>0772-2051867</div>
                    </div>
                  </div>
                </div>
                <div class="inp">
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="keyWord"
                      placeholder="请输入关键词搜索..."
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        @click="$router.push(`richText?keyWord=${keyWord}`)"
                        variant="outline-secondary"
                        ><b-icon icon="search"></b-icon
                      ></b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="minbot">
      <b-button
        @click="model = !model"
        variant="light"
        ><b-icon icon="list"/>
      </b-button>
    </div>
    <div class="menu">
      <b-container>
        <b-row>
          <div class="navList">
            <template v-for="(item, index) in menus">
              <div class="select" v-if="item.children" :key="index">
                <div class="select-title">{{ item.name }}</div>
                <div class="chList">
                  <div
                    class="options"
                    v-for="(ch, idx) in item.children"
                    :key="idx"
                    @click="to(ch, item)"
                  >
                    {{ ch.name }}
                  </div>
                </div>
              </div>
              <div class="select" v-else :key="index" @click="to(item, item)">
                <div class="select-title">{{ item.name }}</div>
              </div>
            </template>
          </div>
        </b-row>
      </b-container>
    </div>
    <div v-show="model" class="model">
      <div class="menu menu1">
        <b-container>
          <b-row>
            <div class="navList">
              <template v-for="(item, index) in menus">
                <div class="select" v-if="item.children" :key="index">
                  <div class="select-title">{{ item.name }}</div>
                  <div class="chList">
                    <div
                      class="options"
                      v-for="(ch, idx) in item.children"
                      :key="idx"
                      @click="to(ch, item)"
                    >
                      {{ ch.name }}
                    </div>
                  </div>
                </div>
                <div class="select" v-else :key="index" @click="to(item, item)">
                  <div class="select-title">{{ item.name }}</div>
                </div>
              </template>
            </div>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/utils/http";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      keyWord: null,
      menus: [], //菜单
      model: false,
    };
  },
  async created() {
    const menu = await request({
      url: "/web/WebMenuController/select",
      method: "get",
    });
    //获取菜单栏
    this.menus = menu.data;
  },
  methods: {
    ...mapMutations(["upIsMenu", "upMenuKey"]),
    to(e, item) {
      if (e.jump == 0) {
        this.upIsMenu(item);
        this.upMenuKey(e.id);
        if (e.type == 0 && e.path) {
          //内部链接
          this.$router.push(e.path);
        }
        if (e.type == 1 && e.path) {
          //外部链接
          window.open(e.path);
        }
        if (e.type == 2 && e.docxId) {
          //文章
          this.$router.push({
            name: "richText-id",
            params: { id: e.docxId },
          });
        }
        if (e.type == 3 && e.path) {
          //其他
          this.$router.push(e.path);
        }
        this.model= false;
      }
    },
  },
};
</script>

<style lang="scss">
.page-header {
  background: white;
  .title {
    background: $theme-6;
    line-height: 2.5em;
    color: white;
    .main {
      font-size: 14px;
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }
  .hand {
    height: 80px;
    display: flex;
    align-items: center;
    .main {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .logo {
          width: 220px;
          img {
            width: 100%;
          }
        }
        .interval {
          height: 50%;
          width: 1px;
          background: $gray-6;
          margin: 0 15px;
        }
        .label {
          font-size: 14px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        .zsrx{
          width: 160px; 
          font-size: 14px;
        }
      }
    }
  }
  .menu {
    width: 100%;
    background: $theme-5;
    line-height: 2.5em;
    height: 2.5em;
    font-size: 16px;
    font-weight: bold;
    .navList {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      .select {
        flex: 1;
        text-align: center;
        color: $gray-4;
        position: relative;
        .select-title {
          cursor: pointer;
        }
        .chList {
          position: absolute;
          bottom: 0;
          display: none;
          z-index: 99;
          background: $theme-5;
          width: 100%;
          transform: translateY(100%);
          font-size: 14px;
          .options {
            line-height: 3em;
            border-bottom: 1px solid $theme-4;
          }
          .options:hover {
            cursor: pointer;
            color: white;
            background: $theme-6;
          }
        }
      }
      .select:hover {
        .select-title {
          color: white;
        }
        .chList {
          display: block;
        }
      }
    }
  }
  .minbot{
    display: none;
  }
  .model{
    position: fixed;
    z-index: 99;
    top: 20px;
    right: 55px;
    width: 160px;
    background: #0464ac;
  }
  @media screen and (max-width: 768px) {
    .hand {
      .main {
        .left {
          .interval,
          .label {
            display: none;
          }
        }
      }
    }
    .title {
      .main{
        display: contents !important;
      }
    }
    .right {
      display: flex;
      align-items: center;
      .zsrx{
        width: 160px !important; 
        font-size: 14px;
      }
      .inp{
        display: none;
      }
    }
    .menu{
      display: none;
    }
    .menu1{
      display: inline !important;
      .navList{
        flex-direction: column;
        justify-content: flex-start;
        .select{
          .chList{
            bottom: 5.1vh;
            right: 160px;
          }
        }
      }
    }
    .minbot{
      display: inline !important;
      position: fixed;
      z-index: 99;
      right: 10px;
      top: 20px;
    }
  }
  @media screen and (min-width: 768px) {
    .model{
      display: none;
    }
  }
}
</style>